// Macro Model
export class Macro {
  constructor(data = {}) {
    this.id = data.id || null;
    this.userId = data.user_id || data.userId || null;
    this.keyword = data.keyword || '';
    // API may use expansion_text (snake) or expansionText (camel)
    this.expansionText = data.expansion_text || data.expansionText || '';
    this.createdAt = data.created_at ? new Date(data.created_at) : (data.createdAt ? new Date(data.createdAt) : null);
    this.updatedAt = data.updated_at ? new Date(data.updated_at) : (data.updatedAt ? new Date(data.updatedAt) : null);
  }

  toJSON() {
    return {
      id: this.id,
      user_id: this.userId,
      keyword: this.keyword,
      expansion_text: this.expansionText,
      created_at: this.createdAt ? this.createdAt.toISOString() : null,
      updated_at: this.updatedAt ? this.updatedAt.toISOString() : null
    };
  }
} 